/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalSubmissionListEntryLeadScreenerLeadInfoRace } from './PalSubmissionListEntryLeadScreenerLeadInfoRace';
import {
    PalSubmissionListEntryLeadScreenerLeadInfoRaceFromJSON,
    PalSubmissionListEntryLeadScreenerLeadInfoRaceFromJSONTyped,
    PalSubmissionListEntryLeadScreenerLeadInfoRaceToJSON,
} from './PalSubmissionListEntryLeadScreenerLeadInfoRace';
import type { PalSubmissionListEntryLeadScreenerLeadInfoState } from './PalSubmissionListEntryLeadScreenerLeadInfoState';
import {
    PalSubmissionListEntryLeadScreenerLeadInfoStateFromJSON,
    PalSubmissionListEntryLeadScreenerLeadInfoStateFromJSONTyped,
    PalSubmissionListEntryLeadScreenerLeadInfoStateToJSON,
} from './PalSubmissionListEntryLeadScreenerLeadInfoState';

/**
 * 
 * @export
 * @interface PalSubmissionListEntryLeadScreenerLeadInfo
 */
export interface PalSubmissionListEntryLeadScreenerLeadInfo {
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    s3_photo_key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    photo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    marital_status?: PalSubmissionListEntryLeadScreenerLeadInfoMaritalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    primary_language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    contact_method_preference?: PalSubmissionListEntryLeadScreenerLeadInfoContactMethodPreferenceEnum;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    current_address?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    race_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    religion?: PalSubmissionListEntryLeadScreenerLeadInfoReligionEnum;
    /**
     * 
     * @type {PalSubmissionListEntryLeadScreenerLeadInfoRace}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    race?: PalSubmissionListEntryLeadScreenerLeadInfoRace;
    /**
     * 
     * @type {PalSubmissionListEntryLeadScreenerLeadInfoState}
     * @memberof PalSubmissionListEntryLeadScreenerLeadInfo
     */
    state?: PalSubmissionListEntryLeadScreenerLeadInfoState;
}


/**
 * @export
 */
export const PalSubmissionListEntryLeadScreenerLeadInfoMaritalStatusEnum = {
    Single: 'single',
    DomesticPartner: 'domestic_partner',
    Married: 'married',
    Separated: 'separated',
    Divorced: 'divorced',
    Widowed: 'widowed',
    UnknownDeclined: 'unknown_declined'
} as const;
export type PalSubmissionListEntryLeadScreenerLeadInfoMaritalStatusEnum = typeof PalSubmissionListEntryLeadScreenerLeadInfoMaritalStatusEnum[keyof typeof PalSubmissionListEntryLeadScreenerLeadInfoMaritalStatusEnum];

/**
 * @export
 */
export const PalSubmissionListEntryLeadScreenerLeadInfoContactMethodPreferenceEnum = {
    Email: 'Email',
    Text: 'Text',
    Call: 'Call',
    Other: 'Other'
} as const;
export type PalSubmissionListEntryLeadScreenerLeadInfoContactMethodPreferenceEnum = typeof PalSubmissionListEntryLeadScreenerLeadInfoContactMethodPreferenceEnum[keyof typeof PalSubmissionListEntryLeadScreenerLeadInfoContactMethodPreferenceEnum];

/**
 * @export
 */
export const PalSubmissionListEntryLeadScreenerLeadInfoReligionEnum = {
    _7thDayAdventist: '7th Day Adventist',
    Atheist: 'Atheist',
    Agnostic: 'Agnostic',
    Apolistic: 'Apolistic',
    Apostolic: 'Apostolic',
    AssemblyOfGod: 'Assembly of God',
    Baptist: 'Baptist',
    Buddhist: 'Buddhist',
    Catholic: 'Catholic',
    Congregational: 'Congregational',
    Christian: 'Christian',
    ChristianScientist: 'Christian Scientist',
    ChurchOfChrist: 'Church of Christ',
    ChristianMissionaryAlliance: 'Christian Missionary Alliance',
    ChurchOfTheNazarene: 'Church of the Nazarene',
    ChristianReformed: 'Christian Reformed',
    Covenant: 'Covenant',
    DisciplesOfChrist: 'Disciples of Christ',
    Episcopalian: 'Episcopalian',
    Evangelical: 'Evangelical',
    FirstAssembly: 'First Assembly',
    GreekOrthodox: 'Greek Orthodox',
    Hinduism: 'Hinduism',
    Islam: 'Islam',
    Judaism: 'Judaism',
    JehovahsWitness: 'Jehovah\'s Witness',
    Lutheran: 'Lutheran',
    ChurchOfTheLatterDaySaints: 'Church of the Latter Day Saints',
    Methodist: 'Methodist',
    Mennonite: 'Mennonite',
    Mormon: 'Mormon',
    Moravian: 'Moravian',
    None: 'None',
    NonDenominational: 'Non-Denominational',
    Orthodox: 'Orthodox',
    Protestant: 'Protestant',
    Pentecostal: 'Pentecostal',
    Presbyterian: 'Presbyterian',
    Quaker: 'Quaker',
    Scientology: 'Scientology',
    Taoist: 'Taoist',
    Traditional: 'Traditional',
    Unitarian: 'Unitarian',
    Unknown: 'Unknown'
} as const;
export type PalSubmissionListEntryLeadScreenerLeadInfoReligionEnum = typeof PalSubmissionListEntryLeadScreenerLeadInfoReligionEnum[keyof typeof PalSubmissionListEntryLeadScreenerLeadInfoReligionEnum];


/**
 * Check if a given object implements the PalSubmissionListEntryLeadScreenerLeadInfo interface.
 */
export function instanceOfPalSubmissionListEntryLeadScreenerLeadInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalSubmissionListEntryLeadScreenerLeadInfoFromJSON(json: any): PalSubmissionListEntryLeadScreenerLeadInfo {
    return PalSubmissionListEntryLeadScreenerLeadInfoFromJSONTyped(json, false);
}

export function PalSubmissionListEntryLeadScreenerLeadInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryLeadScreenerLeadInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        's3_photo_key': !exists(json, 's3_photo_key') ? undefined : json['s3_photo_key'],
        'photo_url': !exists(json, 'photo_url') ? undefined : json['photo_url'],
        'marital_status': !exists(json, 'marital_status') ? undefined : json['marital_status'],
        'primary_language': !exists(json, 'primary_language') ? undefined : json['primary_language'],
        'phone_number': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'contact_method_preference': !exists(json, 'contact_method_preference') ? undefined : json['contact_method_preference'],
        'current_address': !exists(json, 'current_address') ? undefined : json['current_address'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'race_id': !exists(json, 'race_id') ? undefined : json['race_id'],
        'religion': !exists(json, 'religion') ? undefined : json['religion'],
        'race': !exists(json, 'race') ? undefined : PalSubmissionListEntryLeadScreenerLeadInfoRaceFromJSON(json['race']),
        'state': !exists(json, 'state') ? undefined : PalSubmissionListEntryLeadScreenerLeadInfoStateFromJSON(json['state']),
    };
}

export function PalSubmissionListEntryLeadScreenerLeadInfoToJSON(value?: PalSubmissionListEntryLeadScreenerLeadInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        's3_photo_key': value.s3_photo_key,
        'photo_url': value.photo_url,
        'marital_status': value.marital_status,
        'primary_language': value.primary_language,
        'phone_number': value.phone_number,
        'email': value.email,
        'contact_method_preference': value.contact_method_preference,
        'current_address': value.current_address,
        'state_id': value.state_id,
        'race_id': value.race_id,
        'religion': value.religion,
        'race': PalSubmissionListEntryLeadScreenerLeadInfoRaceToJSON(value.race),
        'state': PalSubmissionListEntryLeadScreenerLeadInfoStateToJSON(value.state),
    };
}

